module.exports = __webpack_public_path__ + "static/media/biking-mountain.e3b51a48.svg";